import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import Swal from 'sweetalert2';
import { TokenStorageService } from '../_services/token-storage.service';
import { environmentbasic } from '../../environments/environment-basic';
import { ErrorMessageService } from '../services/error-message.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { switchMap } from 'rxjs/operators';
@Component({
  selector: 'app-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.css']
})
export class MarketplaceComponent implements OnInit {
  showLogin = true;
  showSignup = false;
  showForgot = false;
  showPassword: boolean = false;
  showSignupPassword: boolean = false;
  loginForm!: FormGroup;
  signupForm!: FormGroup;
  forgotForm!: FormGroup;
  loading = false;

  constructor(private fb: FormBuilder,
    private authService: AuthService, private errorMessageService: ErrorMessageService,
    private toastr: ToastrService,
    private router: Router,
    private tokenStorage: TokenStorageService,

  ) { }

  ngOnInit(): void {
    this.initForms();
  }
  onInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  // Allow only alphabetic characters (both uppercase and lowercase)
  input.value = input.value.replace(/[^a-zA-Z]/g, '');

  // Limit to 20 characters
  if (input.value.length > 20) {
    input.value = input.value.slice(0, 20);
  }
}

  initForms(): void {
    this.loginForm = this.fb.group({
      emailusernam: ['', [Validators.required, Validators.email]],
      loginpassword: ['', Validators.required],
    });

    this.signupForm = this.fb.group({
      role: ['Individual', Validators.required],
      fullName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      termsAccepted: [false],
      productUser: ['estate']

    });

    this.forgotForm = this.fb.group({
      forgotemail: ['', [Validators.required, Validators.email]]
    });
  }

  toggle(view: string): void {
    this.showLogin = view === 'login';
    this.showSignup = view === 'signup';
    this.showForgot = view === 'forgot';
  }

  onLoginSubmit(): void {
    if (this.loginForm.valid) {
      console.log('Login Payload:', this.loginForm.value);
      const loginemaill = this.loginForm.get('emailusernam')?.value;
      const loginpass = this.loginForm.get('loginpassword')?.value;
      this.authService.loginUser(loginemaill, loginpass, 'estate')
        .pipe(
          switchMap(response => {
            console.log(response);

            if (response && response.status === "SUCCESS") {
              let accessT = response.payload.access_token;
              const accessToken = response.payload;
              this.tokenStorage.saveToken(JSON.stringify(accessToken));
              const refreshToken = response.payload.refresh_token;
              localStorage.setItem("access_token", accessT);
              const expiresIn = response.payload.expires_in;
              localStorage.setItem("refresh_token", refreshToken);
              localStorage.setItem("expires_in", expiresIn);
              this.tokenStorage.saveSocialOrigin(null);
              this.tokenStorage.saveSocialUserEmail(null);
              this.tokenStorage.saveFirstVisitToHomePageAfterLogin("firstVisit");
              // this.toastr.success('Profile updated successfully!', 'Success');
              return this.authService.getProfileData();

            }
            else if (response['message']) {
              let errorMessage = this.errorMessageService.getErrorMessage(response['message']);
              Swal.fire({
                icon: 'error',
                title: errorMessage,
                showConfirmButton: false,
                timer: environmentbasic.timer
              });
            }
          })
        )
        .subscribe(
          response => {
            if (response) {
              let UserProfile = response;
              localStorage.setItem("UserProfile", JSON.stringify(UserProfile));
              console.log("UserProfile retrieved successfully");

              Swal.fire({
                icon: 'success',
                title: 'You logged in successfully.',
                showConfirmButton: false,
                timer: environmentbasic.timer
              }).then(() => {
                // window.location.reload();
                let currentUrl = this.router.url;
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.router.navigate([currentUrl]);
                window.location.href = '/';
              });
            }
            else if (response['message']) {
              let errorMessage = this.errorMessageService.getErrorMessage(response['message']);
              Swal.fire({
                icon: 'error',
                title: errorMessage,
                showConfirmButton: false,
                timer: environmentbasic.timer
              });
            }
            this.loading = false;
          },
          error => {
            this.loading = false;
            console.error('An error occurred', error);
            const message = error?.error?.message;
            if (message) {
              let errorMessage = this.errorMessageService.getErrorMessage(message);
              Swal.fire({
                icon: 'error',
                title: errorMessage,
                showConfirmButton: false,
                timer: environmentbasic.timer
              });
            }
          }
        );






    } else {
      this.markFormGroupTouched(this.loginForm); // 👈 Add this
      console.log('Login form is invalid');
    }
  }

  onSignupSubmit(): void {
    if (this.signupForm.valid) {
      console.log('Signup Payload:', this.signupForm.value);

      const formValues = this.signupForm.value;
      const role = formValues.role;
      const signuppayload = {
        ...formValues,
        individual: role === 'Individual',
        builder: role === 'Builder',
        agent: role === 'Dealer'
      };

      delete signuppayload.role;

      this.authService.userRegister(signuppayload)
        .pipe(
          switchMap(response => {
            console.log(response);

            if (response && response.status === "SUCCESS") {
              let accessT = response.payload.loginResponse.access_token;
              const accessToken = response.payload;
              this.tokenStorage.saveToken(JSON.stringify(accessToken));
              const refreshToken = response.payload.loginResponse.refresh_token;
              localStorage.setItem("access_token", accessT);
              const expiresIn = response.payload.loginResponse.expires_in;
              localStorage.setItem("refresh_token", refreshToken);
              localStorage.setItem("expires_in", expiresIn);
              this.tokenStorage.saveSocialOrigin(null);
              this.tokenStorage.saveSocialUserEmail(null);
              this.tokenStorage.saveFirstVisitToHomePageAfterLogin("firstVisit");
              // this.toastr.success('Profile updated successfully!', 'Success');
              return this.authService.getProfileData();

            }
            else if (response['message']) {
              let errorMessage = this.errorMessageService.getErrorMessage(response['message']);
              Swal.fire({
                icon: 'error',
                title: errorMessage,
                showConfirmButton: false,
                timer: environmentbasic.timer
              });
            }
          })
        )
        .subscribe(
          response => {
            if (response) {
              let UserProfile = response;
              localStorage.setItem("UserProfile", JSON.stringify(UserProfile));
              console.log("UserProfile retrieved successfully");

              Swal.fire({
                icon: 'success',
                title: 'You logged in successfully.',
                showConfirmButton: false,
                timer: environmentbasic.timer
              }).then(() => {
                // window.location.reload();
                let currentUrl = this.router.url;
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.router.navigate([currentUrl]);
                window.location.href = '/';
              });
            }
            else if (response['message']) {
              let errorMessage = this.errorMessageService.getErrorMessage(response['message']);
              Swal.fire({
                icon: 'error',
                title: errorMessage,
                showConfirmButton: false,
                timer: environmentbasic.timer
              });
            }
            this.loading = false;
          },
          error => {
            this.loading = false;
            console.error('An error occurred', error);
            const message = error?.error?.message;
            if (message) {
              let errorMessage = this.errorMessageService.getErrorMessage(message);
              Swal.fire({
                icon: 'error',
                title: errorMessage,
                showConfirmButton: false,
                timer: environmentbasic.timer
              });
            }
          }
        );

    } else {
      this.markFormGroupTouched(this.signupForm); // 👈 Add this
      console.log('Signup form is invalid');
    }
  }


  onForgotSubmit(): void {
    if (this.forgotForm.valid) {
      console.log('Forgot Password Payload:', this.forgotForm.value);
      const forgotpayload = this.forgotForm.get('forgotemail')?.value;
      this.authService.forgotPassword(forgotpayload).subscribe(
        response => {
          if (response['status'] == 'SUCCESS') {
            Swal.fire({
              icon: 'success',
              title: 'OTP shared over your registered email,please check your inbox.',
              showConfirmButton: false,
              timer: environmentbasic.timer
            });
            this.router.navigate(['/setnewpassword/' + forgotpayload]);
          }
          else if (response['message']) {
            let errorMessage = this.errorMessageService.getErrorMessage(response['message']);
            Swal.fire({
              icon: 'error',
              title: errorMessage,
              showConfirmButton: false,
              timer: environmentbasic.timer
            });
          }
        });
    } else {
      this.markFormGroupTouched(this.forgotForm); // 👈 Add this
      console.log('Forgot form is invalid');
    }
  }
  markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched();
      }
    });
  }

}
